import listDiscount from './listBulkDiscount';
export default listDiscount